module.exports = __webpack_public_path__ + "img/floor_f1_02.e0a70c41.png";